<template>
  <div class="media-grid" :id="'grid-'+item.id">
    <b-overlay :show="Boolean(item._processing)" spinner-small no-wrap>
      <template #overlay>
        <span
          v-if="typeof item._processing === 'string'"
        >{{item._processing}}</span>
      </template>
    </b-overlay>
    <img v-if="src" class="media-image" :class="{faded: hidden}" :src="src" :key="src">
    <span v-else class="centered">⏳</span>
    <div class="info">
      <div class="info-important">
        <span class="h5" v-if="hidden">
          <span class="badge badge-secondary">Unpublished</span>
        </span>
      </div>
      <div class="info-top">
        <span class="h5">
          <span class="badge badge-dark">{{item.price | price}}</span>
        </span>
      </div>
      <div class="info-bottom">
        <div class="info-artist">
          <ArtistInfo
            :item="item"
            :container="'grid-'+item.id"
          ></ArtistInfo>
        </div>
        <div class="info-extra">
          <slot name="extra"></slot>
          <HideButton
            :id="item.id"
            :published.sync="item.published"
            :disabled="isGetty"
            :title="isGetty ? `Getty results cannot be ${item.published ? 'un' : ''}published.` : undefined"
            v-if="user && user.is_staff"
          />
          <StaticButton
            :value="item"
            collection="government"
            v-if="user && user.is_staff"
          />
          <StaticButton
            :value="item"
            collection="commercial"
            v-if="user && user.is_staff"
          />
          <FavButton
            :id="item.id"
            :value="item.user_favorite"
            v-if="user"
          />
          <!--
          <CartButton
            :item="item"
          />
          -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  import ArtistInfo from '@/components/ArtistInfo.vue'
  import FavButton from '@/components/FavButton.vue'
  import HideButton from '@/components/HideButton.vue'
  import StaticButton from '@/components/StaticButton.vue'
  import { isGetty } from '@/components/MediaRelated.vue'
  import { getSrc } from '@/services/media.js'

  export default {
    name: 'MediaGridItem',
    components: {
      ArtistInfo,
      FavButton,
      HideButton,
      StaticButton,
    },
    props: {
      item: Object,
      showStatus: {
        type: Boolean,
        default: true,
      },
    },
    computed: {
      ...mapState('user', [
        'user',
      ]),
      src() {
        return getSrc(this.item)
      },
      hidden() {
        return this.showStatus && !this.item?.published
      },
      isGetty() {
        return isGetty(this.item)
      },
    },
  }
</script>

<style lang="scss" scoped>
.media-grid {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
}
  .media-image {
    width: 100%;
    transition: 0.3s opacity;
  }
  .info {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    pointer-events: none;
    overflow: hidden;
    > * {
      pointer-events: all;
    }
  }
  .info-important,
  .info-top,
  .info-bottom {
    color: white;
    padding: 0 0.5rem;
  }
  .info-important {
    position: absolute;
    padding-top: 0.25rem;
  }
  .info-top {
    position: relative;
    padding-top: 0.25rem;
    text-align: right;
    transition: 0.2s all;
    opacity: 0;
    .media-grid:hover & {
      opacity: 1;
    }
  }
  .info-bottom {
    background: linear-gradient(transparent, rgba(black,0.7));
    margin-top: auto;
    padding-top: 1rem;
    padding-bottom: 0.25rem;
    display: flex;
    align-items: center;
    transition: 0.2s all;
    transform: translateY(100%);
    .media-grid:hover & {
      transform: translateY(0);
    }
  }
  .info-artist {
    overflow: hidden;
  }
  .info-extra {
    margin-left: auto;
    white-space: nowrap;
    > * {
      display: inline-block;
    }
    > * + * {
      margin-left: 0.75rem;
    }
  }
.faded {
  opacity: 0.3;
}
</style>
